import {ComponentType} from 'react';
import {mapStateToProps} from 'epic-localization/src/client/reducers/localization.reducer';
import {MessageProps} from './types';
import MessageCommon from 'epic-localization/src/client/message/Message';

export * from './Message';

const reducerName = 'localization';
export const Message: ComponentType<MessageProps> = MessageCommon(reducerName);
export const mapMessageStateToProps = mapStateToProps(reducerName);

export default Message;
